import React, { useState } from "react";
import Modal from "components/shared/ScopedModal";
import Uploader from "./Uploader";

const UploaderModal = ({
  shopify_customer_id,
  post_image_url,
  buttonClassName,
  buttonLabel,
  onUploadSaved,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className={buttonClassName || "btn btn-sm btn-primary"}
      >
        <i className="fa-solid fa-arrow-up-from-bracket mr-2" aria-hidden="true"></i>
        {buttonLabel || "Upload a file"}
      </button>

      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        center
        classNames={{
          modal: "custom-modal !max-w-2xl",
        }}
      >
        <div className="modal-scroll">
          <div className="p-6">
            <div className="mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Upload Files</h2>
              <p className="text-gray-600 mt-1">
                Upload your images for printing
              </p>
            </div>

            <Uploader
              shopify_customer_id={shopify_customer_id}
              post_image_url={post_image_url}
              onUploadSaved={(data) => {
                closeModal();
                onUploadSaved?.(data);
              }}
            />

            <div className="text-xs mt-12">
              <i className="fa-solid fa-circle-info"></i> Accepted file formats:
              JPG, PNG or TIFF.
              <br />
              Max. file size 100MB / Max. resolution 200 Megapixels.
              <br />
              <a href="/pages/contact" className="underline">
                Contact us
              </a>{" "}
              for special requests.
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UploaderModal;
